import { axios } from '@/utils/request'

let moduleName = 'empInsuranceStandard'

export function selectOne(accountId) {
  console.log('accountId:', accountId)
  return axios({
    url: `/ws/${moduleName}/${accountId}`,
    method: 'get'
  })
}

export default {
  selectOne,
}